// extracted by mini-css-extract-plugin
export default {"user":"UserListElement_user__2Cukp","user__info":"UserListElement_user__info__kP0ao"};